"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mustContainNumber = void 0;
const is_measure_1 = require("../../functions/is-measure/is-measure");
const is_number_1 = require("../../functions/is-number/is-number");
const validation_1 = require("../validation/validation");
/**
 * @summary Creates a `Validation` for number fields.
 *
 * Creates a `Validation` for number fields. If the fields contain any value, validates that the value is a
 * number. It does not matter for this validation if the given value is a number or string type.
 *
 * Note: This validation will also succeed on empty values. If a value must be given, use the `isRequired` validation.
 *
 * @param {string | undefined} message
 * @returns {Validation}
 *
 * @see Validation
 */
function mustContainNumber(message) {
    return (0, validation_1.validation)(message ?? 'The given value must be a number.', (value) => {
        const check = (0, is_measure_1.isMeasure)(value) ? value.value : value;
        if (typeof check === 'string') {
            return !check.trim() || (0, is_number_1.isNumber)(check);
        }
        return true;
    });
}
exports.mustContainNumber = mustContainNumber;
